import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Importing JSON translations
import en from '../../lang/en.json'
import fa from '../../lang/fa.json'
import ps from '../../lang/ps.json'

/*
 * Whether the server drew this page. Its HTML is English, whatever the visitor
 * reads: the language is only known here, in the browser.
 */
const isTakingOver =
  typeof document !== 'undefined' && Boolean(document.getElementById('app')?.hasChildNodes())

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fa: { translation: fa },
      ps: { translation: ps }, // Add Pashto translations
    },
    load: 'languageOnly',
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      /* The language switch saves the visitor's choice itself. Saving here as well would write the English this starts in over it. */
      caches: [],
    },
    interpolation: {
      escapeValue: false,
    },
    cleanCode: true,
  })

/** The language the visitor reads, as the browser has it. */
export const visitorLanguage = (i18n.language || 'en').split('-')[0]

/*
 * While the server's HTML is being taken over the app says what the server
 * said, so the two agree; the entry turns it to the visitor's language once
 * that is done. With nothing to take over it starts in the visitor's language.
 */
i18n.changeLanguage(isTakingOver ? 'en' : visitorLanguage)

export default i18n
